/**
 * Hierarquia de planos: Diamante > Premium > Free.
 *
 * Fonte única de verdade para decidir *qual plano oferecer* a um usuário.
 * Antes disso cada CTA chumbava `premium`, então quem já era Premium via
 * ofertas do próprio plano em vez de ser convidado ao Diamante.
 */

export const PLAN_RANK = {
  free: 0,
  premium: 1,
  diamond: 2,
};

export const PLAN_NAMES = {
  free: "Grátis",
  premium: "Premium",
  diamond: "Diamante",
};

/** Normaliza qualquer entrada (null, undefined, valor desconhecido) para um plano válido. */
export const normalizePlan = (planId) =>
  typeof planId === "string" && Object.hasOwn(PLAN_RANK, planId)
    ? planId
    : "free";

/** Ordem de venda: o próximo degrau acima do plano atual. `null` no topo (Diamante). */
export const getNextPlan = (planId) => {
  const current = normalizePlan(planId);
  if (current === "free") return "premium";
  if (current === "premium") return "diamond";
  return null;
};

/** Nome exibível do próximo plano ("Premium" / "Diamante"), ou string vazia no topo. */
export const getNextPlanName = (planId) => PLAN_NAMES[getNextPlan(planId)] ?? "";

/** true se `planId` já cobre `requiredPlan` (comparação por rank, não igualdade). */
export const planCovers = (planId, requiredPlan = "premium") =>
  PLAN_RANK[normalizePlan(planId)] >= PLAN_RANK[normalizePlan(requiredPlan)];

/** true quando não há mais nada para vender — evita renderizar CTA vazio. */
export const isTopPlan = (planId) => getNextPlan(planId) === null;
